export enum DataProtectionNoticeEndpoint {
  Base = '/documents/dpn',
  Version = '/version',
  Accept = '/document/dpn/accept',
  Last = '/last',
  Content = '/content',
  Country = '/country',
  Public = '/public',
  Publish = '/publish',
}
